import { CONTACT_PROPERTY } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { ENUMERATION } from 'customer-data-objects/property/PropertyTypes';
import { EnumerationDisplayType } from 'customer-data-filters-ui/filterQueryFormat/DisplayTypes';
import { PRIVACY_CONSENT, __PRIVACY_CONSENT } from '../ListSegConstants';
import DSFieldRecord from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import I18n from 'I18n';
import PropertyRecord from 'customer-data-objects/property/PropertyRecord';
import once from 'transmute/once';
export default once(() => DSFieldRecord({
  description: I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.privacyConsent.description'),
  displayType: EnumerationDisplayType,
  label: I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.privacyConsent.label'),
  name: __PRIVACY_CONSENT,
  referencedObjectType: PRIVACY_CONSENT,
  type: ENUMERATION,
  wrappedObject: PropertyRecord({
    description: I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.privacyConsent.description'),
    label: I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.privacyConsent.label'),
    name: __PRIVACY_CONSENT,
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    type: CONTACT_PROPERTY,
    groupName: 'privacy'
  })
}));